import { render } from "./Route.vue?vue&type=template&id=4749e484&scoped=true"
import script from "./Route.vue?vue&type=script&lang=js"
export * from "./Route.vue?vue&type=script&lang=js"

import "./Route.vue?vue&type=style&index=0&id=4749e484&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4749e484"]])

export default __exports__